import { Breadcrumbs } from "@itandi/itandi-bb-ui";
import Link from "next/link";
import type React from "react";
import { DefaultV2 } from "~/components/common/layouts/DefaultV2";
import { ClientSettingLayout } from "~/components/common/layouts/settings/ClientSettingLayout";
import { ImportConversionTable } from "~/components/specifics/settings/imports/[importType]/import_conversions/ImportConversionTable";
import { ImportConversionTop } from "~/components/specifics/settings/imports/[importType]/import_conversions/ImportConversionTop";
import { importTypeLabels, isImportType } from "~/models/ImportLog";
import { PATH as IMPORTS_PATH } from "~/pages/settings/imports";
import { PATH as IMPORT_PATH } from "~/pages/settings/imports/[importType]";
import SettingStyles from "../../../SettingStyle.module.scss";

type Props = {
	importType: string;
};

export const Page: React.FC<Props> = ({ importType }: Props) => {
	if (!isImportType(importType)) {
		return null;
	}

	return (
		<DefaultV2>
			<ClientSettingLayout>
				<div className={SettingStyles.BreadcrumbsBlock}>
					<Breadcrumbs
						items={[
							{
								as: Link,
								href: IMPORTS_PATH,
								label: "過去データ取込"
							},
							{
								as: Link,
								href: IMPORT_PATH(importType),
								label: importTypeLabels[importType]
							},
							{ label: "取込変換設定" }
						]}
					/>
				</div>
				<h2 className={SettingStyles.SettingTitle}>
					{importTypeLabels[importType]}の取込変換設定
				</h2>
				<ImportConversionTop importType={importType} />
				<ImportConversionTable importType={importType} />
			</ClientSettingLayout>
		</DefaultV2>
	);
};
